import React from 'react';
import type { AssignmentExpenseList } from '../../../../../js/api';
import { Dialog, DialogBody, DialogCloseButton, DialogTitle } from '../../../components/dialog';
import { DocumentsTab } from '../../../components/documents-tab';

export const ExpenseDocumentsModal: React.FC<{
  open: boolean;
  onClose: () => void;
  expense?: AssignmentExpenseList;
  ownerId: string;
  relatedProviderId?: string;
}> = ({ open, onClose, expense, ownerId, relatedProviderId }) => {
  if (!expense) return null;

  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <DialogTitle className="tw:flex tw:items-center tw:justify-between">
        <div>
          <div>Expense Documents</div>
          <div className="tw:text-sm tw:font-normal tw:text-zinc-500">
            {expense.expense_category.title}
          </div>
        </div>
        <DialogCloseButton onClick={onClose} />
      </DialogTitle>
      <DialogBody>
        <DocumentsTab
          contextType="assignments.assignmentexpense"
          contextId={expense.id}
          ownerId={ownerId}
          relatedProviderId={relatedProviderId}
        />
      </DialogBody>
    </Dialog>
  );
};
